import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { services } from "@/data/services";
import { SectionHeader } from "@/components/SectionHeader";

export default function ServicesIndex() {
  return (
    <div>
      <section className="pt-16 pb-16 md:pt-24 md:pb-20 border-b border-[#27272a]">
        <div className="absolute inset-0 radial-fade" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
          <div className="max-w-3xl">
            <div className="eyebrow mb-6">
              <span className="gold-line" />
              Services
            </div>
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl text-white leading-[1.05]">
              Everything your presence needs to feel <span className="text-[#C8A24B]">established.</span>
            </h1>
            <p className="mt-8 text-lg text-[#a1a1aa] leading-relaxed max-w-2xl">
              Every service below can be booked individually or bundled into a
              package. Most clients begin with a growth assessment and let the
              plan build itself.
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s) => {
            const Icon = s.icon;
            return (
              <Link
                key={s.slug}
                to={`/services/${s.slug}`}
                data-testid={`services-index-card-${s.slug}`}
                className="group border border-[#27272a] hover:border-[#C8A24B]/50 bg-[#0e0e0e] p-8 rounded-sm transition-all duration-500 hover:-translate-y-1"
              >
                <div className="flex items-start justify-between mb-6">
                  <div className="w-12 h-12 border border-[#27272a] flex items-center justify-center group-hover:border-[#C8A24B] transition-colors">
                    <Icon size={20} className="text-[#C8A24B]" strokeWidth={1.4} />
                  </div>
                  <ArrowUpRight size={18} className="text-[#52525b] group-hover:text-[#C8A24B]" />
                </div>
                <h3 className="font-heading text-xl text-white mb-2">{s.title}</h3>
                <p className="text-sm text-[#a1a1aa] leading-relaxed">{s.short}</p>
              </Link>
            );
          })}
        </div>
      </section>
    </div>
  );
}
